<template>
  <div class="piperun">
    <div class="widget">
      <div class="widget-body">
        <div class="d-flex justify-content-between align-items-center">
          <div class="state">
            <h4>Piperun CRM <small v-if="!activeIntegration">(Inativo)</small></h4>
          </div>
          <div class="icon">
            <div class="d-flex align-items-center">
              <artificial-intelligence-icon add-margin-right="20px" />
              <div v-if="activeIntegration">
                <font
                  size="6"
                  color="black"
                  @click.prevent="toogleUpdateIntegration()">
                  <i class="ik ik-settings" />
                </font>
              </div>
              <div v-else>
                <font
                  size="6"
                  color="gray">
                  <i class="ik ik-settings" />
                </font>
              </div>
            </div>
          </div>
        </div>
        <div class="d-flex justify-content-between align-items-center">
          <small class="text-small mt-10 d-block">
            <toggle-button
              tag="piperun"
              class="mb-1"
              :width="90"
              :height="30"
              :font-size="15"
              :value="activeIntegration"
              :sync="true"
              :labels="{checked: 'Ativo', unchecked: 'Ativar'}"
              @change="toogleIntegration" />
          </small>
          <font
            title="Tutorial"
            size="6"
            color="black"
            @click.prevent="openTutorial">
            <i class="ik ik-youtube" />
          </font>
        </div>
      </div>
    </div>
    <div
      class="modal fade"
      tabindex="-1"
      role="dialog"
      id="confirmDelete"
      ref="confirmDelete"
      data-keyboard="false"
      data-backdrop="static"
      aria-hidden="true">
      <div
        class="modal-dialog modal-dialog-centered"
        role="document">
        <div class="modal-content">
          <div class="modal-header">
            <button
              type="button"
              class="close"
              data-dismiss="modal"
              aria-label="Close">
              <span aria-hidden="true">&times;</span>
            </button>
          </div>
          <div class="modal-body">
            <h4 class="modal-title">Você tem certeza que deseja remover a integração com Piperun CRM?</h4>
          </div>
          <div class="modal-footer">
            <div class="buttons">
              <button
                type="button"
                class="btn btn-outline-secondary"
                data-dismiss="modal">Não</button>
              <button
                type="button"
                class="btn btn-primary"
                @click.prevent="deleteIntegration">Sim</button>
            </div>
          </div>
        </div>
      </div>
    </div>
    <div
      class="modal fade"
      tabindex="-1"
      role="dialog"
      id="updateIntegration"
      ref="updateIntegration"
      data-keyboard="false"
      data-backdrop="static"
      aria-hidden="true">
      <div
        class="modal-dialog modal-dialog-centered"
        role="document">
        <div class="modal-content">
          <div class="modal-header">
            <h4 class="modal-title">Configurar Piperun CRM</h4>
            <div class="d-flex align-items-center">
              <artificial-intelligence-icon />
              <button
                type="button"
                class="close"
                data-dismiss="modal"
                aria-label="Close">
                <span aria-hidden="true">&times;</span>
              </button>
            </div>
          </div>
          <div class="modal-body">
            <div
              v-if="hasError"
              class="alert alert-danger"
              role="alert">
              {{ Object.values(editErrors).join('/r') }}
            </div>
            <p class="text-center">
              Para copiar seu Token
              <a
                class="link"
                href="https://app.pipe.run/v2/integrations"
                target="_blank">
                clique aqui
              </a>
            </p>
            <div class="form-group row">
              <label
                for="piperunToken"
                class="col-sm-4 col-form-label">API token do usuário</label>
              <div class="col-sm-8">
                <input
                  id="piperunToken"
                  type="text"
                  class="form-control"
                  v-model="token">
              </div>
            </div>
            <div v-if="configReady">
              <div class="form-group row">
                <label class="col-sm-4 col-form-label">Usuário PipeRun</label>
                <div class="col-sm-8">
                  <select
                    class="form-control"
                    id="userId"
                    v-model="userId">
                    <option
                      v-for="option in usersOptions"
                      :key="option.value"
                      :value="option.value">
                      {{ option.text }}
                    </option>
                  </select>
                </div>
              </div>
            </div>
          </div>
          <div class="modal-footer">
            <div class="buttons">
              <button
                type="button"
                class="btn btn-primary"
                :disabled="!configReady"
                @click.prevent="saveIntegration">{{ labelSubmit }}</button>
            </div>
          </div>
        </div>
      </div>
    </div>
    <div
      class="modal fade"
      tabindex="-1"
      role="dialog"
      id="successIntegration"
      ref="successIntegration"
      data-keyboard="false"
      data-backdrop="static"
      aria-hidden="true">
      <div
        class="modal-dialog modal-sm modal-dialog-centered"
        role="document">
        <div class="modal-content">
          <div class="modal-header">
            <button
              type="button"
              class="close"
              data-dismiss="modal"
              aria-label="Close">
              <span aria-hidden="true">&times;</span>
            </button>
          </div>
          <div class="modal-body text-center">
            <h5 class="modal-title">Integração com a Piperun CRM atualizada com sucesso!</h5>
          </div>
          <div class="modal-footer">
            <button
              type="button"
              class="btn btn-outline-secondary"
              data-dismiss="modal">OK</button>
          </div>
        </div>
      </div>
    </div>
    <div
      class="modal fade"
      tabindex="-1"
      role="dialog"
      id="uninstallIntegration"
      ref="uninstallIntegration"
      data-keyboard="false"
      data-backdrop="static"
      aria-hidden="true">
      <div
        class="modal-dialog modal-sm modal-dialog-centered"
        role="document">
        <div class="modal-content">
          <div class="modal-header">
            <button
              type="button"
              class="close"
              data-dismiss="modal"
              aria-label="Close">
              <span aria-hidden="true">&times;</span>
            </button>
          </div>
          <div class="modal-body text-center">
            <h5 class="modal-title">Integração Piperun CRM removida com sucesso!</h5>
          </div>
          <div class="modal-footer">
            <button
              type="button"
              class="btn btn-outline-secondary"
              data-dismiss="modal">OK</button>
          </div>
        </div>
      </div>
    </div>
    <tutorial-video-modal
      ref="tutorialPiperun"
      title="Tutorial Piperun CRM"
      video-url="https://www.youtube.com/embed/IGmjeaY3Uss" />
  </div>
</template>

<script>
import loopback from '@/services/loopback'
import PiperunWrapper from '@/services/piperun-wrapper'
import ArtificialIntelligenceIcon from '@/components/Common/ArtificialIntelligenceIcon.vue'
import TutorialVideoModal from '@/components/Common/TutorialVideoModal.vue'

export default {
  name: 'IntegrationPiperun',
  components: {
    ArtificialIntelligenceIcon,
    TutorialVideoModal
  },
  data () {
    return {
      editErrors: null,
      integration: null,
      configReady: false,
      token: null,
      userId: null,
      usersOptions: []
    }
  },
  mounted () {
    this.$nextTick(() => {
      this.loadIntegration().then(_ => this.loadUsers())
    })
  },
  methods: {
    loadIntegration () {
      return loopback
        .get(`/integrations?filter[where][gateway]=piperun`)
        .then(integrations => {
          this.integration = integrations.pop()
          if (this.integration && this.integration.metadata) {
            this.token = this.integration.metadata.token
            this.userId = this.integration.metadata.userId
          }
        })
    },
    saveIntegration () {
      if (this.token && this.configReady) {
        this.editErrors = null
        const integrationParams = {
          gateway: 'piperun',
          webhook: true,
          webhookConstraint: {
            metadata: {
              api4comGateway: 'piperun'
            }
          },
          metadata: {
            token: this.token,
            userId: this.userId,
            webhookUrl: `${process.env.API4COM_BASE_URL_API}${process.env.API4COM_VERSION_API}/integrations/webhook`,
            webhookVersion: 'v1.4',
            webhookTypes: ['channel-hangup']
          }
        }
        const userFound = this.usersOptions.find(user => user.value === this.userId)
        if (userFound) integrationParams.metadata.accountId = userFound.accountId
        if (this.integration) integrationParams.id = this.integration.id
        loopback
          .patch('/integrations', integrationParams)
          .then(integration => {
            this.integration = integration
            $(this.$refs.updateIntegration).modal('hide')
            $(this.$refs.successIntegration).modal('show')
          })
      } else {
        this.editErrors = {
          missingParams: ['Token é obrigatório']
        }
      }
    },
    toogleIntegration (event) {
      if (event.value === true) {
        this.editErrors = null
        $(this.$refs.updateIntegration).modal('show')
      } else {
        $(this.$refs.confirmDelete).modal('show')
      }
    },
    toogleUpdateIntegration () {
      this.editErrors = null
      $(this.$refs.updateIntegration).modal('show')
    },
    deleteIntegration () {
      if (!this.integration) return
      loopback
        .delete(`/integrations/${this.integration.id}`)
        .then(_ => {
          this.integration = null
          this.token = null
          this.userId = null
          this.accountId = null
          this.editErrors = null
          this.configReady = false
          this.usersOptions = []
          $(this.$refs.uninstallIntegration).modal('show')
        })
        .finally(_ => {
          $(this.$refs.confirmDelete).modal('hide')
        })
        .catch(err => { this.$emit('onError', err) })
    },
    loadUsers () {
      if (this.token) {
        PiperunWrapper
          .getUsers(this.token)
          .then(users => {
            if (!this.userId && users[0]) {
              this.userId = users[0].id
            }
            this.usersOptions = []
            users.forEach(user => {
              this.usersOptions.push({
                value: user.id,
                text: `${user.name} (${user.email})`,
                accountId: user.account_id
              })
            })
            this.configReady = true
            this.editErrors = null
          })
          .catch(_ => {
            this.userId = null
            this.usersOptions = []
            this.configReady = false
            this.editErrors = ['Token inválido']
          })
      }
    },
    openTutorial () {
      this.$refs.tutorialPiperun.open()
    }
  },
  computed: {
    activeIntegration () {
      return this.integration && this.integration.gateway === 'piperun'
    },
    hasError () {
      return this.editErrors && Object.keys(this.editErrors).length > 0
    },
    labelSubmit () {
      return this.activeIntegration ? 'Salvar' : 'Ativar'
    }
  },
  watch: {
    token: function (token) {
      if (token) this.loadUsers()
    }
  }
}
</script>

<style lang="scss" scoped>
</style>



// WEBPACK FOOTER //
// src/components/Integration/Piperun.vue